// ─── Demander quelque chose à Permio AI depuis une autre page (18/10/2026) ─────────────────────
// Ex. accueil : « Replanifier avec Permio AI » sur l'absence d'un moniteur. Le volet Messagerie
// s'ouvre sur Permio AI et la demande part aussitôt ; Permio prépare des cartes d'action, rien n'est
// appliqué sans validation.

const ASK_EVENT = 'permio:ask-assistant';

export function askPermioAi(prompt: string) {
  window.dispatchEvent(new CustomEvent<string>(ASK_EVENT, { detail: prompt }));
}

/** Volet Messagerie : écoute les demandes ; rend la fonction de désabonnement. */
export function onAskPermioAi(listener: (prompt: string) => void) {
  const handler = (event: Event) => {
    const prompt = (event as CustomEvent<string>).detail;
    if (typeof prompt === 'string' && prompt.trim()) listener(prompt.trim());
  };
  window.addEventListener(ASK_EVENT, handler);
  return () => window.removeEventListener(ASK_EVENT, handler);
}
